import { createClient, type SupabaseClient } from "@supabase/supabase-js";

import type { Database } from "@/lib/database.types";
import { env, requireSupabaseEnv } from "@/lib/env";

export type TypedSupabaseClient = SupabaseClient<Database>;

let client: TypedSupabaseClient | undefined;

/**
 * Lazily construct the Supabase browser client.
 *
 * This is deliberately not a module-level constant: creating the client at
 * import time would crash the whole app on boot when the environment is not
 * configured yet, instead of letting individual features degrade.
 */
export function getSupabase(): TypedSupabaseClient {
  if (!client) {
    const { url, anonKey } = requireSupabaseEnv();

    client = createClient<Database>(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: "pkce",
      },
    });
  }

  return client;
}

/** Whether a Supabase client can be constructed at all. */
export const isSupabaseConfigured = env.hasSupabase;
